import { App, getServerSideProps } from 'map-search'
import { useEffect } from 'react'
import Analytics from 'react-ga4'

const Search = (props) => {
  useEffect(() => {
    // TODO: Move this to utils package
    // Save page view whenever a user view this page.
    Analytics.send({
      hitType: 'pageview',
      page: '/search'
    })
  }, [])

  return <App userGeolocation={props.userGeolocation} />
}

export default Search
export { getServerSideProps }
